export function validacionRut(rut) {
    rut = formatearRut(rut);
    let valor = rut.replace(/\./g, "");
    valor = valor.replace(/\-/g, "");
    const cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    let suma = 0;
    let multiplo = 2;
    for (let i = 1; i <= cuerpo.length; i++) {
      const index = multiplo * valor.charAt(cuerpo.length - i);
      suma = suma + index;
      if (multiplo < 7) {
        multiplo = multiplo + 1;
      } else {
        multiplo = 2;
      }
    }
    const dvEsperado = 11 - (suma % 11);
    dv = dv === "K" ? 10 : dv;
    dv = dv === "0" ? 11 : dv;
  
    if (dvEsperado != dv) {
      return false;
    }
    return true;
}

function formatearRut(rut) {
    rut = numerosRut(rut);
    if (rut.length > 1) {
      rut = rut.substring(0, rut.length - 1) + "-" + rut.charAt(rut.length - 1);
    }
    return rut;
}

function rutDV(rut) {
  let dv = rut.slice(-1).toUpperCase();
  return dv;
}

function rutNoDV(rut) {
  rut = numerosRut(rut);
  return rut.slice(0, -1);
}

export function numerosRut(rut) {
  //remove all characters except numbers and K character
  return rut.replace(/[^0-9kK]+/g, "");
}
  